
import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import NotFound from '../pages/NotFound';
import Login from '../pages/login/page';
import Dashboard from '../pages/dashboard/page';
import Transfer from '../pages/transfer/page';
import History from '../pages/history/page';
import Reports from '../pages/reports/page';
import Profile from '../pages/profile/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Login />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/dashboard',
    element: <Dashboard />,
  },
  {
    path: '/transfer',
    element: <Transfer />,
  },
  {
    path: '/history',
    element: <History />,
  },
  {
    path: '/reports',
    element: <Reports />,
  },
  {
    path: '/profile',
    element: <Profile />,
  },
  {
    path: '/home',
    element: <Home />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
